import { sendGoogleEvent, sendAmplitudeEvent } from '@html/_common/utils';

export default class AOTourBookingIntent {
  constructor(eventCategory, scrollTo) {
    this.eventCategory = eventCategory;
    this.scrollTo = scrollTo;

    this.selector = '.js-ao-tour__booking-intent';
  }

  init() {
    $('body').on('click', this.selector, (event) => {
      const $target = $(event.currentTarget);
      sendAmplitudeEvent({
        ampEventName: 'tdp_availability_button_clicked',
        click_source: 'price_block',
      });
      sendGoogleEvent(
        this.eventCategory,
        $target.data('action'),
        $target.data('label'),
        {
          ampEventName: $target.data('param-ampeventname'),
        },
      );

      if ($target.attr('href')) {
        return;
      }

      if (typeof ($.magnificPopup) !== 'undefined') {
        $.magnificPopup.close();
      }

      event.preventDefault();
      this.scrollTo('check', $target.text());
    });
  }
}
